import axios from 'axios'
import { API_HOST } from "../../api_utils";
import { ADD_ORGANISATION_FAILED, ADD_ORGANISATION_LOADING, ADD_ORGANISATION_SUCCESS, APPROVE_REQUEST_LIST_FAILED, APPROVE_REQUEST_LIST_LOADING, APPROVE_REQUEST_LIST_SUCCESS, DELETE_LIST_OF_ORGANISATION_FAILED, DELETE_LIST_OF_ORGANISATION_LOADING, DELETE_LIST_OF_ORGANISATION_SUCCESS, DELETE_LIST_OF_USER_UNDER_COMPANY_FAILED, DELETE_LIST_OF_USER_UNDER_COMPANY_LOADING, DELETE_LIST_OF_USER_UNDER_COMPANY_SUCCESS, DELETE_REQUEST_LIST_FAILED, DELETE_REQUEST_LIST_LOADING, DELETE_REQUEST_LIST_SUCCESS, GET_ARCHIVE_LIST_FAILED, GET_ARCHIVE_LIST_LOADING, GET_ARCHIVE_LIST_SUCCESS, GET_LIST_OF_USER_UNDER_COMPANY_FAILED, GET_LIST_OF_USER_UNDER_COMPANY_LOADING, GET_LIST_OF_USER_UNDER_COMPANY_SUCCESS, GET_ORGANISATION_DETAILS_FAILED, GET_ORGANISATION_DETAILS_LOADING, GET_ORGANISATION_DETAILS_SUCCESS, GET_ORGANISATION_EMPLOYEES_FAILED, GET_ORGANISATION_EMPLOYEES_LOADING, GET_ORGANISATION_EMPLOYEES_SUCCESS, GET_ORGANISATION_FAILED, GET_ORGANISATION_LOADING, GET_ORGANISATION_SUCCESS, GET_REQUEST_LIST_FAILED, GET_REQUEST_LIST_LOADING, GET_REQUEST_LIST_SUCCESS, RESTORE_PROJECT_FAILED, RESTORE_PROJECT_LOADING, RESTORE_PROJECT_SUCCESS, UPDATE_LIST_OF_USER_UNDER_COMPANY_FAILED, UPDATE_LIST_OF_USER_UNDER_COMPANY_LOADING, UPDATE_LIST_OF_USER_UNDER_COMPANY_SUCCESS } from '../Constants/adminScreenConstants';
import { toast } from "react-toastify";



const errorTheme = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
}



export const getAdminRequest = () => async (dispatch, getState) => {
    try {

        dispatch({ type: GET_REQUEST_LIST_LOADING })
        const { userLogin: { userInfo } } = getState()
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }
        const { data } = await axios.get(`${API_HOST}adminRequests`, config)
        dispatch({ type: GET_REQUEST_LIST_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: GET_REQUEST_LIST_FAILED, payload: 'Invalid Email or Password' })

    }
}

export const updateAdminRequest = (request_id) => async (dispatch, getState) => {
    try {

        dispatch({ type: APPROVE_REQUEST_LIST_LOADING })
        const { userLogin: { userInfo } } = getState()
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }
        const { data } = await axios.post(`${API_HOST}adminRequests/request`, {request_id:request_id,action:"approve"}, config)
        dispatch({ type: APPROVE_REQUEST_LIST_SUCCESS, payload: data })
        toast.success(`Application Approved successfully  .`, errorTheme)
    } catch (error) {
        dispatch({ type: APPROVE_REQUEST_LIST_FAILED, payload: 'Invalid Email or Password' })

    }
}

export const addOrganisationRequest= (organisationData)=> async(dispatch, getState)=>{
    try {
        dispatch({ type: ADD_ORGANISATION_LOADING })
        const { userLogin: { userInfo } } = getState()

        const formData = new FormData();
        Object.keys(organisationData).forEach(key => {
            formData.append(key, organisationData[key]);
        });

        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${userInfo.token}`
            }
        }
        const { data } = await axios.post(`${API_HOST}organisation/create`, formData, config)
        dispatch({ type: ADD_ORGANISATION_SUCCESS, payload: data })
        toast.success(`Organisation created successfully  .`, errorTheme)
        return Promise.resolve();
    } catch (error) {
        dispatch({ type: ADD_ORGANISATION_FAILED, payload: 'Creation failed' })
        toast.error(error.response.data.message || "Creation failed")
        return Promise.reject();
    }
}

export const deleteAdminRequest = (request_id) => async (dispatch, getState) => {

    console.log("request_id:::::::", request_id);
    try {

        dispatch({ type: DELETE_REQUEST_LIST_LOADING })
        const { userLogin: { userInfo } } = getState()
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        const { data } = await axios.post(`${API_HOST}adminRequests/request`, {request_id:request_id, action: "decline"}, config)
        dispatch({ type: DELETE_REQUEST_LIST_SUCCESS, payload: data })
        toast.success(`Application Discarded successfully  .`, errorTheme)
    } catch (error) {
        dispatch({ type: DELETE_REQUEST_LIST_FAILED, payload: 'Invalid Email or Password' })

    }
}

export const getUsersUnderCompany = () => async (dispatch, getState) => {
    try {

        dispatch({ type: GET_LIST_OF_USER_UNDER_COMPANY_LOADING })
        const { userLogin: { userInfo } } = getState()
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }
        const { data } = await axios.get(`${API_HOST}adminRequests/user_list`, config)
        dispatch({ type: GET_LIST_OF_USER_UNDER_COMPANY_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: GET_LIST_OF_USER_UNDER_COMPANY_FAILED, payload: 'Invalid Email or Password' })

    }
}

export const getOrganisation = () => async(dispatch, getState)=>{
    try {
        dispatch({ type: GET_ORGANISATION_LOADING })
        const { userLogin: { userInfo } } = getState()
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }
        const { data } = await axios.get(`${API_HOST}organisation`, config)
        dispatch({ type: GET_ORGANISATION_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: GET_ORGANISATION_FAILED, payload: 'Invalid Token' })
    }
}

export const getArchiveList = () => async(dispatch, getState)=>{
    try {
        dispatch({ type: GET_ARCHIVE_LIST_LOADING })
        const { userLogin: { userInfo } } = getState()
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }
        const { data } = await axios.get(`${API_HOST}projects/archived`, config)
        dispatch({ type: GET_ARCHIVE_LIST_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: GET_ARCHIVE_LIST_FAILED, payload: 'Invalid Token' })
    }
}

export const updateUsersUnderCompany = (userData) => async (dispatch, getState) => {
    try {
        dispatch({ type: UPDATE_LIST_OF_USER_UNDER_COMPANY_LOADING })
        const { userLogin: { userInfo } } = getState()
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }
        const { data } = await axios.put(`${API_HOST}adminRequests/user_list`, userData, config)
        dispatch({ type: UPDATE_LIST_OF_USER_UNDER_COMPANY_SUCCESS, payload: data })
        toast.success(`user successfully updated .`, errorTheme)
    } catch (error) {
        dispatch({ type: UPDATE_LIST_OF_USER_UNDER_COMPANY_FAILED, payload: 'Invalid Email or Password' })
    }
}

export const deleteUsersUnderCompany = (user_id) => async (dispatch, getState) => {
    try {

        dispatch({ type: DELETE_LIST_OF_USER_UNDER_COMPANY_LOADING })
        const { userLogin: { userInfo } } = getState()
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }
        const { data } = await axios.delete(`${API_HOST}adminRequests/user_list/${user_id}`, config)
        dispatch({ type: DELETE_LIST_OF_USER_UNDER_COMPANY_SUCCESS, payload: data })
        toast.success(`user successfully deleted .`, errorTheme)
    } catch (error) {
        dispatch({ type: DELETE_LIST_OF_USER_UNDER_COMPANY_FAILED, payload: 'Invalid Email or Password' })

    }
}



export const deleteOrgnisation = (user_id) => async (dispatch, getState) => {
    try {

        dispatch({ type: DELETE_LIST_OF_ORGANISATION_LOADING })
        const { userLogin: { userInfo } } = getState()
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }
        const { data } = await axios.delete(`${API_HOST}organisation/${user_id}`, config)
        dispatch({ type: DELETE_LIST_OF_ORGANISATION_SUCCESS, payload: data })
        toast.success(`Organisation successfully deleted .`, errorTheme)
    } catch (error) {
        dispatch({ type: DELETE_LIST_OF_ORGANISATION_FAILED, payload: 'Error' })

    }
}


export const restoreProject = (project_id) => async (dispatch, getState) => {
    try {

        dispatch({ type: RESTORE_PROJECT_LOADING })
        const { userLogin: { userInfo } } = getState()
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }
        const { data } = await axios.put(`${API_HOST}projects/restore/${project_id}`, config)
        dispatch({ type: RESTORE_PROJECT_SUCCESS, payload: data })
        toast.success(`Project restore successfully.`, errorTheme)
    } catch (error) {
        dispatch({ type: RESTORE_PROJECT_FAILED, payload: 'Error' })
    }
}

export const getOrganisationDetails = (org_id) => async(dispatch, getState)=>{
    try {
        dispatch({ type: GET_ORGANISATION_DETAILS_LOADING })
        const { userLogin: { userInfo } } = getState()
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }
        const { data } = await axios.get(`${API_HOST}organisation/${org_id}`, config)
        dispatch({ type: GET_ORGANISATION_DETAILS_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: GET_ORGANISATION_DETAILS_FAILED, payload: 'Invalid Token' })
    }
}

export const getOrganisationEpmployeeList = (org_id) => async(dispatch, getState)=>{
    try {
        dispatch({ type: GET_ORGANISATION_EMPLOYEES_LOADING })
        const { userLogin: { userInfo } } = getState()
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }
        const { data } = await axios.get(`${API_HOST}organisation/get-employees/${org_id}`, config)
        dispatch({ type: GET_ORGANISATION_EMPLOYEES_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: GET_ORGANISATION_EMPLOYEES_FAILED, payload: 'Invalid Token' })
    }
}